import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { CreateFunnelStepInterface, FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { FunnelStepSourceEnum } from 'shared/enums/funnel-step-type-enum';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useAddFunnelStep = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      addFunnelStep: (id, data) => {
        if (data.funnelStepSource === FunnelStepSourceEnum.StartFromScratch) {
          return fetcher(`${FUNNELS_API}/${id}/steps/empty`, {
            name: data.name,
            type: data.type
          });
        }
        return fetcher(`${FUNNELS_API}/${id}/steps`, {
          name: data.name,
          type: data.type
        });
      }
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};